/**
 * Changing the login dropdown behavior
 */
(() => {
  const shoppingtoolsContainer = document.querySelector('.shoppingtools_container .toolbar');

  shoppingtoolsContainer.addEventListener('click', (e) => {
    e.preventDefault();
    const accountSlidein = document.querySelector('.login-slidein');
    if (!accountSlidein) return;
    accountSlidein.classList.add('account-slidein--active');
  });
})();

// ** Replaces images in minicart
(() => {
  const imageError = () => {
    const placeholderUrl = 'https://us.evocdn.io/dealer/1407/content/media/My_Theme/ke-coming-soon-image.png'; // make sure this url works
    const images = document.querySelectorAll('.minicart img');
    images.forEach((image) => {
      if (image.src === 'https://keencompressedgas.us.evostore.io/img/picture-100.png') {
        image.src = placeholderUrl;
      }
    });
  };
  // document.addEventListener('product-loadmore-success', () => {
  //   setTimeout(() => { // To stop the code bugging out and replacing all images with the placeholder
  //     imageError();
  //   }, 10);
  // }, false);
  // document.addEventListener('live-inventory-done', () => { // Run code when inventory has loaded
  //   setTimeout(() => {
  //     imageError();
  //   }, 10);
  // }, false);
  setTimeout(() => { // Fallback in case inventory is removed
    imageError();
  }, 100);
})();
